/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podiums`)
};

const es_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podios`)
};

const de_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podien`)
};

const nl_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podiums`)
};

const fr_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podiums`)
};

const it_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podi`)
};

const pt_br2_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pódios`)
};

const pt_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pódios`)
};

const ja_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表彰台`)
};

const zh_f1_standings_col_podiums = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登台`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_col_podiums = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_col_podiums(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_col_podiums", locale)
	if (locale === "en") return en_f1_standings_col_podiums(inputs)
	if (locale === "es") return es_f1_standings_col_podiums(inputs)
	if (locale === "de") return de_f1_standings_col_podiums(inputs)
	if (locale === "nl") return nl_f1_standings_col_podiums(inputs)
	if (locale === "fr") return fr_f1_standings_col_podiums(inputs)
	if (locale === "it") return it_f1_standings_col_podiums(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_col_podiums(inputs)
	if (locale === "pt") return pt_f1_standings_col_podiums(inputs)
	if (locale === "ja") return ja_f1_standings_col_podiums(inputs)
	return zh_f1_standings_col_podiums(inputs)
};